import { IconProps } from "../../utils/global-types/global-types";

const KnowledgeBaseIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-5 h-5"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M3.448 2.888h-.002a.57.57 0 0 0-.57.573v8.585c0 .315.258.572.574.572 1.332.004 3.565.281 5.106 1.893V5.527a.55.55 0 0 0-.08-.29C7.214 3.2 4.784 2.89 3.449 2.888M15.124 12.046V3.461a.57.57 0 0 0-.57-.573h-.002c-1.335.003-3.765.313-5.029 2.349a.55.55 0 0 0-.078.29v8.984c1.54-1.612 3.773-1.89 5.105-1.893a.574.574 0 0 0 .573-.572"
    ></path>
    <path
      fill="currentColor"
      d="M16.428 4.868h-.416v7.178c0 .804-.655 1.46-1.46 1.461-1.13.003-2.994.224-4.314 1.473 2.283-.559 4.69-.195 6.061.117A.57.57 0 0 0 17 14.54v-9.1a.573.573 0 0 0-.573-.572M1.988 12.046V4.868h-.416A.573.573 0 0 0 1 5.441v9.098a.57.57 0 0 0 .7.558c1.372-.312 3.779-.676 6.062-.117-1.32-1.249-3.184-1.47-4.314-1.473a1.465 1.465 0 0 1-1.46-1.46"
    ></path>
  </svg>
);

export default KnowledgeBaseIcon;
